<template>
  <div class="label-list">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>住户姓名</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入住户姓名" v-model="table.search.name"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>手机号</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入手机号" v-model="table.search.phone"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>房屋身份</p>
          </a-col>
          <a-col>
            <a-select class="app-block" v-model="table.search.identity" placeholder="请选择房屋身份">
              <a-select-option :value="1">{{houseIdentityText(1)}}</a-select-option>
              <a-select-option :value="2">{{houseIdentityText(2)}}</a-select-option>
              <a-select-option :value="3">{{houseIdentityText(3)}}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-row class="mg-normal">
      <a-col>
        <a-space>
          <a-button type="primary" @click="modal.show = true">新增住户</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange">
      <template slot="action" slot-scope="text, data">
        <a-space>
          <a-button type="link" @click="deleteResident(data)">移除</a-button>
        </a-space>
      </template>
    </a-table>
    <a-modal :title="modal.title" v-model="modal.show" @ok="confirmModal" destroy-on-close width="60%" centered>
      <tree-select v-model="modal.resident" :data="tree.data" :params="tree.params" :load-data="$houseTreeData" multiple @load="loadTreeSelectNode"></tree-select>
    </a-modal>
  </div>
</template>

<script>
  import {
    houseIdentityText
  } from '@/io/dict.js';
  import LabelService from '@/io/label.js';

  export default {
    name: 'LabelList',
    props: {
      communityId: {
        type: Number,
        default: null
      },
      id: {
        type: Number,
        default: null
      },
    },
    data() {
      let self = this;
      return {
        houseIdentityText,
        table: {
          loading: false,
          search: {
            name: null,
            phone: null,
            identity: []
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '住户姓名',
              dataIndex: 'name'
            },
            {
              title: '手机号',
              dataIndex: 'mobile'
            },
            {
              title: '房屋身份',
              dataIndex: 'identity'
            },
            {
              title: '所属房屋',
              dataIndex: 'housing'
            },
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            }
          ]
        },
        tree: {
          data: [],
          params: {
            children: 'children',
            title: 'name',
            key: '_id'
          }
        },
        modal: {
          title: '选择住户',
          show: false,
          resident: []
        },
      }
    },
    watch: {
      id: {
        handler(newValue, oldValue) {
          this.searchTable();
        },
        immediate: true
      },
    },
    mounted () {
      this.initTreeData();
    },
    methods: {
      loadTreeSelectNode(data) {
        data.children.forEach(val => {
          this.$set(val, 'disabled', val.level <= 4);
        });
      },
      initTreeData() {
        return this.$houseTreeData([], [this.isPlatformRole ? 0 : 1, 5]).then(res => {
          this.tree.data = res.map(val => {
            val.disabled = true;
            return val;
          });
        });
      },
      confirmModal() {
        LabelService.addResident(this.id, this.modal.resident.map(val => val.id)).then(() => {
          this.initData();
        }).catch(err => {}).finally(() => {
          this.modal.show = false;
        });
      },
      deleteResident(data) {
        let self = this;
        this.$confirm({
          title: '提示',
          content: '确认移除此住户？',
          onOk() {
            LabelService.delResident(self.id, [data.id]).then(res => {
              self.initData();
            }).catch(err => {});
          }
        });
      },
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
      resetSearchTable() {
        this.table.search = {
          name: null,
          phone: null,
          identity: []
        };
        this.searchTable();
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      initData() {
        this.table.loading = true;
        this.$emit('total', 0);
        LabelService.residentListPage(
          this.id,
          this.table.search.name,
          this.table.search.phone,
          this.table.search.identity,
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            return val;
          });
          this.table.page.total = res.meta.pagination.total;
          this.$emit('total', res.meta.pagination.total);
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>